<button (click)="click.emit()"
  class="bx--modal-close"
  type="button"
  [attr.data-modal-close]="autoclose ? true : undefined"
  aria-label="close modal"
  title="Close">
  <ibm-icon-close></ibm-icon-close>
</button>